/**
 * Created by Yunxuan Yan on 2017/8/18.
 */
import Component from "../../../lib/component";
import template from './contract-control.html';
import {PMAPI} from "../../../lib/postmsg";
import {HTTP} from "../../../lib/http";
import './contract-control.scss'
import {Storage} from '../../../lib/storage';

let config = {
    template:template,
    data: {
        historyList:[],
        iframe_key:'',
    },
    binds:[
        {
            event:'click',
            selector:'.contract-view',
            callback:function () {
                if(!this.data.isAdd) {
                    this.data['mode'] = 'view';
                    this.actions.openEditor('查看');
                }
            }
        },{
            event:'click',
            selector:'.contract-edit',
            callback:function () {
                this.data['mode']='edit';
                this.actions.openEditor('编辑');
            }
        }
    ],
    actions:{
        openEditor:function(title){
            // let contractConfig = _.defaultsDeep({data:this.data},contractEditorConfig);
            PMAPI.openDialogByIframe(`/iframe/contractEditor/`, {
                width: 1400,
                height: 810,
                title: title,
                modal: true,
                iszoom:true,
            }, {data:this.data}).then(res => {
                Storage.init(this.data.iframe_key);
                if(res.onlyclose){
                    let obj = Storage.getItem('contractCache-'+this.data.real_id+'-'+this.data.id+'-'+this.data.temp_id+'-'+this.data.field_id,Storage.SECTION.FORM);
                    if(obj == undefined){
                        return;
                    }
                    for (let data of obj) {
                        delete data['content'];
                        delete data['mode'];
                    }
                    this.data.value = obj;
                } else {
                    this.data.value = res;
                }
                this.trigger('changeValue',this.data);
            })

        },
        // getHistoryModel: function (json) {
        //     return HTTP.postImmediately('/customize/rzrk/show_lastest_history/', json);
        // }

    },

    afterRender:function () {
        if(this.data['is_view']){
            this.el.find('.contract-edit').css('display','none');
        }
        if(this.data.isAdd) {
            this.el.find('.contract-view').eq(0).css({'color':'#999999'});
        }
        // let obj = {
        //     dfield: this.data.dfield,
        //     table_id: this.data.table_id
        // }
        // this.actions.getHistoryModel(obj).then(res=> {
        //     for(let item of res.data) {
        //         for(let i in item) {
        //             let json = {}
        //             json['id'] = i;
        //             json['name'] = item[i].substring(0,item[i].length-5)
        //             this.data.historyList.push(json)
        //         }
        //     }
        // })
        if((new URL(document.URL)).searchParams!=undefined){
            this.data.iframe_key = new URL(document.URL).searchParams.get('key');
        } else {
            let params = (new URL(document.URL)).search.split("&");
            params.forEach((param)=>{
                if(param.indexOf('key')!=-1){
                     this.data.iframe_key = param.replace('key=','');
                }
            })
        }

    }
}
let ContractControl = Component.extend(config)
export default ContractControl


// WEBPACK FOOTER //
// app/components/form/contract-control/contract-control.js